import {
  faCalendarDay,
  faCalendarWeek,
  faDropletSlash,
  faHandsHoldingHeart,
  faHandHoldingHeart,
  faHandHoldingSeedling,
  faHeart,
  faJackOLantern,
  faLeaf,
  faPhone,
  faRabbitRunning,
  faSparkles,
  faStar,
  faTreeChristmas,
  faWheatSlash
} from "@fortawesome/pro-solid-svg-icons";
import { faHourglassClock } from "@fortawesome/pro-regular-svg-icons";

import { logger } from "~/services/logger";

export const PRODUCT_TAGS_LIST = [
  {
    key: "vegan",
    names: {
      da: "Vegansk",
      en: "Vegan",
      no: "Vegan",
      nl: "Veganistisch",
      sv: "Vegan",
      el: "Vegan",
      pl: "Wegański",
      it: "Vegano",
      pt: "Vegano",
      uk: "Веган",
      ro: "Vegan",
      fr: "Végétalien",
      de: "Vegan",
      es: "Vegano",
      hu: "Vegán",
      bg: "Веган",
      zh: "纯素",
      tr: "Vegan",
      ga: "Veigeán"
    },
    background: `linear-gradient(107.57deg, #48BB78 -18.83%, #38A169 124.05%)`,
    color: "#48BB78",
    faIcon: faHandHoldingSeedling
  },
  {
    key: "vegetarian",
    names: {
      da: "Vegetar",
      en: "Vegetarian",
      no: "Vegetarisk",
      nl: "Vegetarisch",
      sv: "Vegetarisk",
      el: "Χορτοφάγος",
      pl: "Wegetariański",
      it: "Vegetariano",
      pt: "Vegetariano",
      uk: "Вегетаріанський",
      ro: "Vegetarian",
      fr: "Végétarien",
      de: "Vegetarisch",
      es: "Vegetariano",
      hu: "Vegetáriánus",
      bg: "Вегетариански",
      zh: "素食",
      tr: "Vejetaryen",
      ga: "Feoilséantóir"
    },
    background: `linear-gradient(107.57deg, #48BB78 -18.83%, #38A169 124.05%)`,
    color: "#48BB78",
    faIcon: faLeaf
  },
  {
    key: "glutenFree",
    names: {
      da: "Glutenfri",
      en: "Gluten Free",
      no: "Glutenfri",
      nl: "Glutenvrij",
      sv: "Glutenfri",
      el: "Χωρίς γλουτένη",
      pl: "Bezglutenowy",
      it: "Senza glutine",
      pt: "Sem glúten",
      uk: "Безглютеновий",
      ro: "Fără gluten",
      fr: "Sans gluten",
      de: "Glutenfrei",
      es: "Sin gluten",
      hu: "Gluténmentes",
      bg: "Без глутен",
      zh: "无麸质",
      tr: "Glutensiz",
      ga: "Saor ó ghlútan"
    },
    faIcon: faWheatSlash
  },
  {
    key: "lactoseFree",
    names: {
      da: "Laktosefri",
      en: "Lactose Free",
      no: "Laktosefri",
      nl: "Lactosevrij",
      sv: "Laktosfri",
      el: "Χωρίς λακτόζη",
      pl: "Bez laktozy",
      it: "Senza lattosio",
      pt: "Sem lactose",
      uk: "Без лактози",
      ro: "Fără lactoză",
      fr: "Sans lactose",
      de: "Laktosefrei",
      es: "Sin lactosa",
      hu: "Laktózmentes",
      bg: "Без лактоза",
      zh: "无乳糖",
      tr: "Laktozsuz",
      ga: "Saor ó lachtós"
    },
    faIcon: faDropletSlash
  },
  {
    key: "organic",
    names: {
      da: "Øko",
      en: "Organic",
      no: "Øko",
      nl: "Eco",
      sv: "Eko",
      el: "Οικολογικό",
      pl: "Organiczny",
      it: "Biologico",
      pt: "Orgânico",
      uk: "Органічний",
      ro: "Organic",
      fr: "Bio",
      de: "Bio",
      es: "Orgánico",
      hu: "Bio",
      bg: "Органичен",
      zh: "有机",
      tr: "Organik",
      ga: "Orgánach"
    },
    background: `linear-gradient(114.18deg, #E30613 -19.33%, #E30613 131.99%)`,
    color: "#E30613"
  },
  {
    key: "almostOrganic",
    names: {
      da: "Delvist Øko",
      en: "Partly Organic",
      no: "Delvis Øko",
      nl: "Gedeeltelijk Eco",
      sv: "Delvis Eko",
      el: "Μερικώς Οικολογικό",
      pl: "Częściowo organiczny",
      it: "Parzialmente biologico",
      pt: "Parcialmente orgânico",
      uk: "Частково органічний",
      ro: "Parțial organic",
      fr: "Partiellement bio",
      de: "Teilweise Bio",
      es: "Parcialmente orgánico",
      hu: "Részben bio",
      bg: "Частично органичен",
      zh: "部分有机",
      tr: "Kısmen organik",
      ga: "Beagnach orgánach"
    },
    background: `linear-gradient(114.18deg, #E30613 -19.33%, #E30613 131.99%)`,
    color: "#E30613"
  },
  {
    key: "popular",
    names: {
      da: "Populær",
      en: "Popular",
      no: "Populær",
      nl: "Populair",
      sv: "Populär",
      el: "Δημοφιλής",
      pl: "Popularny",
      it: "Popolare",
      pt: "Popular",
      uk: "Популярний",
      ro: "Popular",
      fr: "Populaire",
      de: "Beliebt",
      es: "Popular",
      hu: "Népszerű",
      bg: "Популярен",
      zh: "流行",
      tr: "Popüler",
      ga: "Coitianta"
    },
    background: `linear-gradient(114.18deg, #ECC94B -19.33%, #D69E2E 131.99%)`,
    color: "#ECC94B",
    faIcon: faStar
  },
  {
    key: "halal",
    names: {
      da: "Halal",
      en: "Halal",
      no: "Halal",
      nl: "Halal",
      sv: "Halal",
      el: "Χαλάλ",
      pl: "Halal",
      it: "Halal",
      pt: "Halal",
      uk: "Халяль",
      ro: "Halal",
      fr: "Halal",
      de: "Halal",
      es: "Halal",
      hu: "Halal",
      bg: "Халал",
      zh: "清真",
      tr: "Helal",
      ga: "Halal"
    },
    background: `linear-gradient(114.18deg, #054020 -19.33%, #17661F 131.99%)`,
    color: "#2F855A"
  },
  {
    key: "sensoryDiet",
    names: {
      da: "Sensorisk kost",
      en: "Sensory diet",
      no: "Sensorisk kosthold",
      nl: "Sensorisch dieet",
      sv: "Sensorisk kost",
      el: "Αισθητηριακή διατροφή",
      pl: "Dieta sensoryczna",
      it: "Dieta sensoriale",
      pt: "Dieta sensorial",
      uk: "Sensory Diet",
      ro: "Dieta senzorială",
      fr: "Régime sensoriel",
      de: "Sensorische Diät",
      es: "Dieta sensorial",
      hu: "Érzékszervi étrend",
      bg: "Сензорна диета",
      zh: "感官饮食",
      tr: "Duyusal diyet",
      ga: "Aiste bia céadfach"
    },
    faIcon: faHandsHoldingHeart
  },
  {
    key: "leftovers",
    names: {
      da: "Overskudsmad",
      en: "Surplus food",
      no: "Overskuddsmat",
      nl: "Overtollig voedsel",
      sv: "Överskottsmat",
      el: "Υπόλοιπο φαγητό",
      pl: "Żywność nadwyżkowa",
      it: "Cibo in eccesso",
      pt: "Comida excedente",
      uk: "Зайві продукти",
      ro: "Mâncare în exces",
      fr: "Aliments en surplus",
      de: "Überschüssige Lebensmittel",
      es: "Alimentos excedentes",
      hu: "Túl sok étel",
      bg: "Излишък храна",
      zh: "剩余食物",
      tr: "Artık yiyecek",
      ga: "Fuílleach"
    },
    background: `linear-gradient(114.18deg, #48BB78 -19.33%, #38A169 131.99%)`,
    color: "#48BB78",
    faIcon: faHeart
  },
  {
    key: "madeWithLeftovers",
    names: {
      da: "Lavet med rester",
      en: "Made with leftovers",
      no: "Laget med rester",
      nl: "Gemaakt met restjes",
      sv: "Gjord med rester",
      el: "Φτιαγμένο με υπολείμματα",
      pl: "Zrobione z resztek",
      it: "Fatto con gli avanzi",
      pt: "Feito com sobras",
      uk: "Зроблено з залишків",
      ro: "Făcut cu resturi",
      fr: "Fait avec des restes",
      de: "Hergestellt aus Resten",
      es: "Hecho con sobras",
      hu: "Maradékokból készült",
      bg: "Направено с остатъци",
      zh: "用剩菜做的",
      tr: "Artıklarla yapıldı",
      ga: "Déanta le fuílleach"
    },
    background: `linear-gradient(114.18deg, #48BB78 -19.33%, #38A169 131.99%)`,
    color: "#48BB78",
    faIcon: faHandHoldingHeart
  },
  {
    key: "new",
    names: {
      da: "Nyhed",
      en: "New item",
      no: "Nyhet",
      nl: "Nieuw artikel",
      sv: "Nyhet",
      el: "Νέο στοιχείο",
      pl: "Nowy przedmiot",
      it: "Nuovo articolo",
      pt: "Novo item",
      uk: "Новий елемент",
      ro: "Articol nou",
      fr: "Nouvel article",
      de: "Neuer Artikel",
      es: "Nuevo artículo",
      hu: "Új elem",
      bg: "Нов артикул",
      zh: "新项目",
      tr: "Yeni madde",
      ga: "Mír nua"
    },
    background: `linear-gradient(114.18deg, rgba(121,166,255,1) -19.33%, rgba(0,117,208,1) 131.99%)`,
    color: "rgba(121,166,255,1)",
    faIcon: faSparkles
  },
  {
    key: "onlyToday",
    names: {
      da: "Kun i dag",
      en: "Only today",
      no: "Bare i dag",
      nl: "Alleen vandaag",
      sv: "Bara idag",
      el: "Μόνο σήμερα",
      pl: "Tylko dzisiaj",
      it: "Solo oggi",
      pt: "Apenas hoje",
      uk: "Тільки сьогодні",
      ro: "Doar azi",
      fr: "Aujourd'hui seulement",
      de: "Nur heute",
      es: "Solo hoy",
      hu: "Csak ma",
      bg: "Само днес",
      zh: "只有今天",
      tr: "Sadece bugün",
      ga: "Inniu amháin"
    },
    background: `linear-gradient(114.18deg, #ECC94B -19.33%, #D69E2E 131.99%)`,
    color: "#ECC94B",
    faIcon: faCalendarDay
  },
  {
    key: "onlyThisWeek",
    names: {
      da: "Kun i denne uge",
      en: "Only this week",
      no: "Bare denne uken",
      nl: "Alleen deze week",
      sv: "Bara den här veckan",
      el: "Μόνο αυτή την εβδομάδα",
      pl: "Tylko w tym tygodniu",
      it: "Solo questa settimana",
      pt: "Apenas esta semana",
      uk: "Тільки цього тижня",
      ro: "Doar în această săptămână",
      fr: "Cette semaine seulement",
      de: "Nur diese Woche",
      es: "Solo esta semana",
      hu: "Csak ezen a héten",
      bg: "Само тази седмица",
      zh: "只有本周",
      tr: "Sadece bu hafta",
      ga: "An tseachtain seo amháin"
    },
    background: `linear-gradient(114.18deg, #ECC94B -19.33%, #D69E2E 131.99%)`,
    color: "#ECC94B",
    faIcon: faCalendarWeek
  },
  {
    key: "urgentSale",
    names: {
      da: "Først til mølle",
      en: "First come, first served",
      no: "Førstemann til mølla",
      nl: "Wie het eerst komt, het eerst maalt",
      sv: "Först till kvarn",
      el: "Πρώτος που έρχεται, πρώτος που εξυπηρετείται",
      pl: "Kto pierwszy, ten lepszy",
      it: "Chi arriva prima, meglio alloggia",
      pt: "Quem chegar primeiro, melhor",
      uk: "Хто перший, того й тапки",
      ro: "Cine vine primul, mănâncă",
      fr: "Premier arrivé, premier servi",
      de: "Wer zuerst kommt, mahlt zuerst",
      es: "El que llega primero, mejor",
      hu: "Aki először jön, először szolgál",
      bg: "Който първи идва, първи обслужва",
      zh: "先到先得",
      tr: "İlk gelen, ilk hizmet",
      ga: "Tagadh do sheal mar a tháinig tú féin"
    },
    background: `linear-gradient(114.18deg, rgba(192,159,255,1) -19.33%, rgba(176,93,255,1) 131.99%)`,
    color: "rgba(192,159,255,1)",
    faIcon: faHourglassClock
  },
  {
    key: "contactKitchen",
    names: {
      da: "Kontakt Køkken",
      en: "Contact kitchen",
      no: "Kontakt kjøkkenet",
      nl: "Contact keuken",
      sv: "Kontakta köket",
      el: "Επικοινωνία με την κουζίνα",
      pl: "Skontaktuj się z kuchnią",
      it: "Contatta la cucina",
      pt: "Contate a cozinha",
      uk: "Зв'яжіться з кухнею",
      ro: "Contactați bucătăria",
      fr: "Contacter la cuisine",
      de: "Küche kontaktieren",
      es: "Contactar con la cocina",
      hu: "Kapcsolatfelvétel a konyhával",
      bg: "Свържете се с кухнята",
      zh: "联系厨房",
      tr: "Mutfakla iletişime geçin",
      ga: "Teagmháil leis an gcistin"
    },
    background: `linear-gradient(114.18deg, rgba(192,159,255,1) -19.33%, rgba(176,93,255,1) 131.99%)`,
    color: "rgba(192,159,255,1)",
    faIcon: faPhone
  },
  {
    key: "christmas",
    names: {
      da: "Julespecial",
      en: "Christmas Special",
      no: "Julespesial",
      nl: "Kerstspecial",
      sv: "Julspecial",
      el: "Χριστουγεννιάτικο",
      pl: "Świąteczny",
      it: "Speciale di Natale",
      pt: "Especial de Natal",
      uk: "Різдвяний",
      ro: "Special de Crăciun",
      fr: "Spécial Noël",
      de: "Weihnachtsspezial",
      es: "Especial de Navidad",
      hu: "Karácsonyi különlegesség",
      bg: "Коледен",
      zh: "圣诞特别",
      tr: "Noel özel",
      ga: "Speisialta na Nollag"
    },
    background: `linear-gradient(107.57deg, #C11411 -18.83%, #A10805 124.05%)`,
    color: "#C11411",
    faIcon: faTreeChristmas
  },
  {
    key: "halloween",
    names: {
      da: "Halloween Special",
      en: "Halloween Special",
      no: "Halloweenspesial",
      nl: "Halloweenspecial",
      sv: "Halloweenspecial",
      el: "Ειδικό Halloween",
      pl: "Specjalny Halloween",
      it: "Speciale di Halloween",
      pt: "Especial de Halloween",
      uk: "Спеціальний Хеллоуїн",
      ro: "Special de Halloween",
      fr: "Spécial Halloween",
      de: "Halloween-Spezial",
      es: "Especial de Halloween",
      hu: "Halloween különlegesség",
      bg: "Хелоуин",
      zh: "万圣节特别",
      tr: "Cadılar Bayramı özel",
      ga: "Speisialta na Oíche Shamhna"
    },
    background: `linear-gradient(107.57deg, #FF6F59 -18.83%, #DB504A 124.05%)`,
    color: "#FF6F59",
    faIcon: faJackOLantern
  },
  {
    key: "easter",
    names: {
      da: "Påskespecial",
      en: "Easter Special",
      no: "Påskespesial",
      nl: "Paasspecial",
      sv: "Påskspecial",
      el: "Πάσχα",
      pl: "Wielkanocny",
      it: "Speciale di Pasqua",
      pt: "Especial de Páscoa",
      uk: "Великодній",
      ro: "Special de Paște",
      fr: "Spécial Pâques",
      de: "Osterspezial",
      es: "Especial de Pascua",
      hu: "Húsvéti különlegesség",
      bg: "Великден",
      zh: "复活节特别",
      tr: "Paskalya özel",
      ga: "Speisialta na Cásca"
    },
    background: `linear-gradient(107.57deg, #FFE97C -18.83%, #FAE062 124.05%)`,
    color: "#FFE97C",
    faIcon: faRabbitRunning
  },
  {
    key: "plantBased",
    names: {
      da: "Plantebaseret",
      en: "Plant based",
      no: "Plantebasert",
      nl: "Plantaardig",
      sv: "Växtbaserad",
      el: "Φυτική βάση",
      pl: "Na bazie roślin",
      it: "A base vegetale",
      pt: "Baseado em plantas",
      uk: "На рослинній основі",
      ro: "Pe bază de plante",
      fr: "À base de plantes",
      de: "Auf pflanzlicher Basis",
      es: "A base de plantas",
      hu: "Növényi alapú",
      bg: "На растителна основа",
      zh: "植物基",
      tr: "Bitki bazlı",
      ga: "Bunaithe ar phlandaí"
    },
    background: `linear-gradient(107.57deg, #0cbd62 -18.83%, #38A169 124.05%)`,
    color: "#0cbd62",
    faIcon: faHandHoldingSeedling
  }
] as const;

export type ProductTagType = (typeof PRODUCT_TAGS_LIST)[number];

export function getProductTagInformation({
  name,
  languageCode
}: {
  name: string;
  languageCode: keyof ProductTagType["names"];
}) {
  const tag = PRODUCT_TAGS_LIST.find((tag) => tag.key === name);

  if (!tag) {
    logger.warn(`Product tag ${name} not found`);
    return null;
  }

  return {
    key: tag.key,
    backgroundColor: "color" in tag ? tag.color : undefined,
    faIcon: "faIcon" in tag ? tag.faIcon : undefined,
    iconImage:
      "faIcon" in tag
        ? undefined
        : `https://storage.googleapis.com/kanpla-87be3.appspot.com/allergenIcons/${tag.key}.svg`,
    label: tag.names[languageCode]
  };
}
